import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedOrphanedRoute extends BaseRoute {}
